import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'components/form/formik';
import { useMemo } from 'react';
import { PlusIcon } from '@phosphor-icons/react';
import toast from 'react-hot-toast';

import { Button } from '../../../../components/button/Button';
import { useAllGeneralSettings } from '../../all-settings-context';
import { CheckboxField } from '../../../../components/checkbox/CheckboxField';
import { InputField } from '../../../../components/input/InputField';
import { SimpleSelectField } from '../../../../components/select/SimpleSelectField';
import { MailboxTypeSelectOptions } from './constants';
import { MailboxType } from 'src/types/enums';
import { createMailbox } from '../../models';
import { getDisplayError } from '../../../../utils/get-display-error';
import { captureException } from '@sentry/react';

const newMailboxSchema = Yup.object().shape({
  name: Yup.string().min(1, 'Vereist').required('Vereist'),
  type: Yup.mixed().nullable().required('Vereist'),
  imapHost: Yup.string().min(1, 'Vereist').required('Vereist'),
  imapPort: Yup.string().matches(/\d+/, 'Moet een getal zijn').min(1, 'Vereist').required('Vereist'),
  imapTls: Yup.boolean(),
  imapUser: Yup.string().min(1, 'Vereist').required('Vereist'),
  imapPassword: Yup.string().min(1, 'Vereist').required('Vereist'),
});

export const ConfigureMailboxPage = () => {
  const navigate = useNavigate();
  const { refreshData } = useAllGeneralSettings();

  const initialValues = useMemo(() => {
    return {
      type: MailboxTypeSelectOptions[0],
      name: '',
      imapHost: '',
      imapPort: '',
      imapUser: '',
      imapPassword: '',
      imapTls: true,
    };
  }, []);

  return (
    <div className="grid gap-4">
      <h2 className="heading-two">Configureer nieuwe mailbox</h2>

      <Formik
        initialValues={initialValues}
        validationSchema={newMailboxSchema}
        onSubmit={async (values) => {
          try {
            await createMailbox({
              ...values,
              type: values.type.key as MailboxType,
              imapPort: +values.imapPort,
            });
            refreshData();
            toast.success('Mailbox aangemaakt');
            navigate('..');
          } catch (err) {
            captureException(err);
            toast.error('Kon mailbox niet aanmaken: ' + getDisplayError(err));
          }
        }}
      >
        {({ handleSubmit, isSubmitting, values, setFieldValue }) => (
          <form onSubmit={handleSubmit} className="grid gap-4">
            <div className="card p-5">
              <SimpleSelectField labelText="Type" items={MailboxTypeSelectOptions} name="type" />

              <InputField labelText="Naam" type="text" name="name" />
              <InputField labelText="IMAP UserIcon" type="text" name="imapUser" />
              <InputField labelText="IMAP Password" type="password" name="imapPassword" />

              <InputField labelText="IMAP Host" type="text" name="imapHost" />
              <InputField labelText="IMAP Port" type="number" name="imapPort" />
              <CheckboxField labelText="IMAP TLS" name="imapTls" />
            </div>

            <div>
              <Button
                type="submit"
                color="primary"
                isDisabled={isSubmitting}
                isLoading={isSubmitting}
                iconLeft={<PlusIcon className="button-icon" />}
              >
                Maak mailbox aan
              </Button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};
